<template>
  <div id="show-client-portal-transaction">
    <v-card class="mt-3">
      <v-card-title> Liste des Transactions CB </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <cb-transaction-datatable
          :clientPortal="clientPortal"
        ></cb-transaction-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import CbTransactionDatatable from "@/components/Group/CbTransactionDatatable";

export default {
  props: {
    clientPortal: Object,
  },
  components: { CbTransactionDatatable },
  setup() {},
};
</script>
